import React, { Fragment } from 'react';
import { ExampleCard } from 'Components/Form/ExmpleCard';

export const ExamplesCard: React.FC<any> = () => {
  return (
    <Fragment>
      <ExampleCard />
    </Fragment>
  ); 
}